import React, { useEffect, useState } from "react";
import {
  postDomain,
  updateDomain,
  getDomainById,
} from "../../../api/domain.service";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, Link } from "react-router";
import constant from "../../../utils/constant";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import Breadcrumb from "../../shared/common/breadcrumb";
import { getPassagessourceType } from "../../../api/passage.service";
import Select from "react-select";
import { getSubjectAllByContent } from "../../../api/subject.service";
import { connect } from "react-redux";
import Loader from "../../shared/loader/loader";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import { IDomain } from "../../../model/interface/domain";
import { IAutoFillData } from "../../../model/interface/autoFillData";
import ManageDomainsAndStandards from "../../shared/common/manageDomainsAndStandards";
import { toast } from "react-toastify";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { useNumericParam } from "../../../utils/useNumericParam";

const defaultValue: any = {};
const ManageDomain = () => {
  const defaultSubjectValue: ISelectElement = {
    label: "",
    value: "0",
  };
  const defaultSourceType: ISelectElement = {
    label: "",
    value: "0",
  };

  const [domainToEdit, setDomainToEdit] = useState<IDomain>();
  const [subjects, setSubjects] = useState<ISelectElement[]>([]);
  const [selectedSubject, setSelectedSubject] =
    useState<ISelectElement>(defaultSubjectValue);

  const [sourceTypeData, setSourceTypeData] = useState([]);
  const [selectedSourceType, setSelectedSourceType] =
    useState<any>(defaultSourceType);
  const [loading, setLoading] = useState<boolean>(false);
  const [autoFillData, setAutoFillData] = useState<IAutoFillData>();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isValidTestPercentage, setIsValidTestPercentage] =
    useState<boolean>(true);
  const [isValidLoadOrder, setIsValidLoadOrder] = useState<boolean>(true);
  const [lang, setLang] = useState<number>(1);
  const [contentArea, setContentArea] = useState([]);
  const [selectedContentArea, setselectedContentArea] = useState(defaultValue);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const id = useNumericParam("id");

  const location = useLocation();
  const parameters = location.state as any;

  const getContent = async (contentId?: number) => {
    const module = await import("../../../api/contentArea.service");
    const response = module.getContentArea(999, 1);
    const data = (await response).data;
    let contentDropdownData: any = [];
    if (data.data.length > 0) {
      contentDropdownData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.contentAreaId || 0,
          label: `${eachContentData.name}`,
        };
      });
      if (contentId) {
        const selectedContent = contentDropdownData?.filter(
          (ds) => ds.value === contentId
        )[0];
        setselectedContentArea(selectedContent);
      }
    }
    setContentArea(contentDropdownData);
  };
  const getDomain = async (domainId?: number) => {
    if (domainId && domainId > 0) {
      const domain = {
        name: "0",
        subjectId: "0",
        domainId: domainId,
        orderByColumn: "name",
        sortByDesc: "ASC",
        pageSize: 999,
        pageNumber: 1,
        isActive: true,
      };
      const response = getDomainById(domainId);
      const domainData = await response;
      setDomainToEdit(domainData.data);
      sourceTypeHandler(domainData.data.sourceTypeId);
      bindSubjects(domainData.data.subjectId, domainData.data.contentAreaId);
      getContent(domainData.data.contentAreaId);
    } else {
      sourceTypeHandler(0);

      if (parameters?.autoFillData?.contentId) {
        getContent(parameters?.autoFillData.contentId);
        bindSubjects(
          parameters?.autoFillData.subjectId,
          parameters?.autoFillData.contentId
        );
      } else {
        getContent();
        bindSubjects(0);
      }
    }
  };

  const onSubmit = async (data: any) => {
    setIsLoaded(true);
    if ("target" in data) return;
    if (
      !domainToEdit?.name ||
      !domainToEdit.testPercentage ||
      !domainToEdit.loadOrder ||
      !selectedSubject?.value ||
      !selectedSourceType.value
    )
      return;

    const postObject: any = {
      name: domainToEdit?.name,
      domainId: domainToEdit?.domainId ? domainToEdit?.domainId : 0,
      sourceType:
        selectedSourceType.value == "0" ? "" : selectedSourceType.label,
      sourceTypeId:
        selectedSourceType.value == "0" ? null : selectedSourceType.value,
      subjectId: selectedSubject?.value,
      testPercentage: domainToEdit.testPercentage,
      loadOrder: domainToEdit.loadOrder,
      contentAreaId: selectedContentArea.value,
      userId: "1",
      isApproved: domainToEdit.isApproved ? domainToEdit.isApproved : true,
    };

    if (domainToEdit?.spanishName) {
      postObject.spanishName = domainToEdit.spanishName;
    }

    setLoading(true);
    if (id) {
      updateDomain(postObject).then(() => {
        setLoading(false);
        toast.success("Domain edited successfully");
        if (parameters?.redirectBack) {
          navigate(-1);
        } else {
          constant.EDITDOMAIN.replace(":id", id?.toString());
        }
      });
    } else {
      const data = await postDomain(postObject);
      setLoading(false);
      toast.success(`Domain added successfully, ID- ${data.data}`);
      if (parameters?.redirectBack) {
        navigate(-1);
      } else {
        navigate(constant.DOMAINS);
      }
    }
  };

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Domain", url: constant.DOMAINS },

      { name: id ? "Edit Domain" : "Add Domain", url: "" },
    ];

    if (id) {
      items.push({ name: id?.toString(), url: "" });
    }

    return items;
  };

  const sourceChangeHandler = (selectedItem) => {
    setSelectedSourceType(selectedItem);
  };

  async function sourceTypeHandler(sourceTypeId: number) {
    const response = getPassagessourceType();
    const data = (await response).data;
    const sourceTypeData = data.map((item) => {
      return { label: item.name, value: item.id };
    });
    setSourceTypeData(sourceTypeData);

    if (sourceTypeId) {
      const selectedSourceType = sourceTypeData.find((t) => {
        return t.value === sourceTypeId;
      });

      setSelectedSourceType(selectedSourceType);
    } else {
      setSelectedSourceType(defaultSourceType);
    }
  }

  function bindSubjects(subjectId: number, contentAreaId?: number) {
    setLoading(true);
    getSubjectAllByContent(contentAreaId ? contentAreaId : 0).then(
      (response) => {
        setLoading(false);
        const result = response.data;
        const subjectsData = result?.map((item) => {
          return { label: item.subjectName, value: item.subjectId };
        });
        if (subjectId) {
          const subjectAutoFill = result
            ?.filter((t) => {
              return t.subjectId == subjectId;
            })
            ?.map((item) => {
              return {
                contentId: contentAreaId,
                subjectId: item.subjectId,
                domainId: id,
              };
            });
          setAutoFillData(subjectAutoFill[0]);
        }
        if (subjectsData.length > 0) setSubjects(subjectsData);
        else setSubjects([defaultSubjectValue]);

        if (id || subjectId) {
          const selectedSubject = subjectsData?.find((t) => {
            return t?.value === subjectId;
          });

          if (selectedSubject) setSelectedSubject(selectedSubject);
          else setSelectedSubject(defaultSubjectValue);
        } else if (parameters?.autoFillData) {
          if (
            subjectsData.length > 0 &&
            parameters?.autoFillData?.subjectId &&
            parameters?.autoFillData?.contentId == selectedContentArea.value
          ) {
            const selectedSubject = subjectsData?.find((t) => {
              return t?.value === parameters?.autoFillData?.subjectId;
            });
            setSelectedSubject(selectedSubject);
          } else {
            setSelectedSubject(defaultSubjectValue);
          }
        }
      }
    );
  }

  function handleSubjectChange(selectedItem: any) {
    setIsLoaded(true);
    setSelectedSubject(selectedItem);
  }
  function handleContentAreaChange(selectedItem: any) {
    setIsLoaded(true);
    setselectedContentArea(selectedItem);
    setSelectedSubject(defaultSubjectValue);
    if (selectedItem.value) bindSubjects(0, selectedItem.value);
  }

  useEffect(() => {
    const domainId = id;
    if (domainId === 0) {
      navigate(constant.BAD_REQUEST, { replace: true });
    } else if (domainId) {
      getDomain(domainId);
    } else {
      getDomain();
    }
  }, [id]);

  const onChange = (e, type) => {
    const { value } = e.target;
    setIsLoaded(true);

    if (type === "name") {
      const data: any = { ...domainToEdit, name: value };
      setDomainToEdit(data);
    }

    if (type === "spanishName") {
      const data: any = { ...domainToEdit, spanishName: value };
      setDomainToEdit(data);
    }

    if (type === "testPercentage") {
      const data: any = { ...domainToEdit, testPercentage: value };
      setDomainToEdit(data);
      setIsValidTestPercentage(validate(value, "testPercentage"));
    }

    if (type === "loadOrder") {
      const data: any = { ...domainToEdit, loadOrder: value };
      setDomainToEdit(data);
      setIsValidLoadOrder(validate(value, "loadOrder"));
    }
  };

  function handleRedirection(name: string, id: number) {
    if (name === "subject" && id) {
      navigate(constant.SUBJECTDETAIL.replace(":id", id.toString()), {
        state: { subjectType: 1 },
      });
    } else if (name && id) {
      navigate(`/${name}/edit/${id}`);
    } else {
      navigate(`/${name}`);
    }
  }

  const validate = (value, type) => {
    if (type === "testPercentage" && /^[0-9]*$/.test(value)) {
      return true;
    }

    if (type === "loadOrder" && /^[1-9]\d*$/.test(value)) {
      return true;
    }

    return false;
  };

  const toggleLang = () => {
    if (lang === 1) {
      setLang(2);
    } else {
      setLang(1);
    }
  };

  return (
    <AllowedTo
      perform={[Permissions.domain_create, Permissions.domain_modify]}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      <div className="w-full">
        <div className="flex-1 overflow-auto ">
          <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 overflow-y-auto mt-7 ">
            <div className="relative  py-1">
              <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-light text-gray-900">
                  {id ? "Edit Domain " : "Add Domain "}
                </h3>
              </div>
              <Breadcrumb items={breadcrumbItems()} />
              <div className="flex">
                <form onSubmit={handleSubmit(onSubmit)} className="w-2/5 mr-14">
                  <div className="shadow py-6 border rounded-lg mt-4 px-4 w-full">
                    <div className="flex justify-end">
                      <div
                        className="inline-block border text-sm border-gray-300 overflow-hidden rounded-md mb-4"
                        onClick={() => toggleLang()}
                      >
                        <span
                          className={`${
                            lang === 1
                              ? "bg-primary-color text-white"
                              : "bg-white text-gray-400"
                          } inline-block dark:text-white w-20 py-0.5 text-center cursor-pointer hover:opacity-80`}
                        >
                          English
                        </span>
                        <span
                          className={`${
                            lang === 2
                              ? "bg-primary-color text-white"
                              : "bg-white text-gray-400"
                          } w-20 py-0.5 inline-block text-center  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                        >
                          Spanish
                        </span>
                      </div>
                    </div>
                    <div>
                      <div className="grid grid-cols-1 ">
                        <div className="text-sm">
                          <label className="font-medium text-gray-700">
                            Name
                          </label>
                        </div>
                        <div>
                          <input
                            type="text"
                            defaultValue={domainToEdit?.name}
                            autoComplete="off"
                            className={`${
                              lang === 1 ? "" : "hidden"
                            } mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                            onChange={(e) => onChange(e, "name")}
                          />

                          <input
                            type="text"
                            defaultValue={domainToEdit?.spanishName}
                            autoComplete="off"
                            className={`${
                              lang === 2 ? "" : "hidden"
                            } mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                            onChange={(e) => onChange(e, "spanishName")}
                          />

                          {isLoaded && !domainToEdit?.name && (
                            <span className="pt-1 inline-block text-red-700 text-sm">
                              Name is required.
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm flex items-center col-span-1">
                          {selectedContentArea?.value ? (
                            <a
                              className="text-gray-700 text-sm underline"
                              onClick={() =>
                                handleRedirection(
                                  "content-areas",
                                  parseInt(selectedContentArea?.value)
                                )
                              }
                              href={`/content-areas/edit/${parseInt(
                                selectedContentArea?.value
                              )}`}
                            >
                              Content Area
                            </a>
                          ) : (
                            <button className="text-gray-700 text-sm cursor-default">
                              Content Area
                            </button>
                          )}
                        </div>
                        <div
                          id="contentAreaFilter"
                          className="block mt-1 w-full col-span-3 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                        >
                          <Select
                            name="contentArea"
                            value={selectedContentArea}
                            options={contentArea}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            onChange={handleContentAreaChange}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                          />
                          {isLoaded &&
                            Object.keys(selectedContentArea).length === 0 && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Content area is required.
                              </span>
                            )}
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm flex items-center ">
                          <a
                            className="text-gray-700 text-sm underline"
                            onClick={() =>
                              handleRedirection(
                                "subject",
                                parseInt(selectedSubject?.value)
                              )
                            }
                            href={constant.SUBJECTDETAIL.replace(
                              ":id",
                              selectedSubject?.value.toString()
                            )}
                          >
                            Subject
                          </a>
                        </div>
                        <div className="mt-1">
                          <Select
                            value={selectedSubject}
                            onChange={handleSubjectChange}
                            options={subjects}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                            className="text-gray-900 cursor-default select-none relative py-2"
                            isSearchable={true}
                          />
                          {isLoaded && selectedSubject.value === "0" && (
                            <span className="pt-1 inline-block text-red-700 text-sm">
                              Subject is required.
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm">
                          <label className="font-medium text-gray-700 whitespace-nowrap">
                            Test Percentage
                          </label>
                        </div>
                        <div>
                          <input
                            type="text"
                            defaultValue={domainToEdit?.testPercentage}
                            autoComplete="off"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                            onChange={(e) => onChange(e, "testPercentage")}
                          />
                          {isLoaded && !domainToEdit?.testPercentage && (
                            <span className="text-red-700 inline-block pt-1 text-sm">
                              Test percentage is required
                            </span>
                          )}
                          {isLoaded &&
                            domainToEdit?.testPercentage &&
                            !isValidTestPercentage && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Require Numbers Only(Greater than 0)
                              </span>
                            )}
                        </div>
                      </div>
                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm">
                          <label className="font-medium text-gray-700 whitespace-nowrap ">
                            Source Type
                          </label>
                        </div>
                        <div className="col-span-3">
                          <Select
                            options={sourceTypeData}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                            onChange={sourceChangeHandler}
                            className="w-full mt-1"
                            value={selectedSourceType}
                            isSearchable={true}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm">
                          <label className="font-medium text-gray-700 ">
                            Load Order
                          </label>
                        </div>
                        <div>
                          <input
                            type="text"
                            defaultValue={
                              domainToEdit && domainToEdit.loadOrder
                            }
                            maxLength={2}
                            autoComplete="off"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                            onChange={(e) => onChange(e, "loadOrder")}
                          />
                          {isLoaded && !domainToEdit?.loadOrder?.toString() && (
                            <span className="text-red-700 inline-block pt-1 text-sm">
                              Load Order is required.
                            </span>
                          )}
                          {isLoaded &&
                            domainToEdit?.loadOrder?.toString() &&
                            !isValidLoadOrder && (
                              <span className="text-red-700 inline-block pt-1 text-sm">
                                Required Numbers Only
                              </span>
                            )}
                        </div>
                      </div>

                      <div className="flex justify-end mt-8 items-center border-t ">
                        <button
                          type="submit"
                          onClick={onSubmit}
                          className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                        >
                          {id ? "Update " : "Save"}
                        </button>
                        <Link to={constant.DOMAINS} className="ml-2">
                          <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                            Cancel
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </form>
                {id && (
                  <ManageDomainsAndStandards
                    showTestPercent={false}
                    domainId={id}
                    autoFillData={autoFillData}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(ManageDomain);
